import CoverageSection from '../../../GeneralComponents/GlobalCoverage';

import Styles from '../styles.module.scss';

const BrokersDataSection = () => (
  <div className={Styles['brokers-data-section']}>
    <div className={Styles.section}>
      <h2>With Broad and Global Coverage</h2>
      <CoverageSection
        itemsColorType="transparent"
      />
    </div>
  </div>
);

export default BrokersDataSection;
